<div class="min-h-100 mx-auto grid w-full max-w-screen-lg grid-cols-1 gap-4">
  <div class="flex w-full flex-auto flex-col gap-4">
    @if (resultResource.isLoading()) {
    <div class="flex h-full w-full items-center justify-center">
      <p-progress-spinner />
    </div>
    } @else if (resultResource.hasValue()) { @let eval = resultResource.value();
    @if (!eval!.isEvaluated) { @if (evaluationRequested()) {
    <lib-result-progress-card
      data-tour="result-progress"
      [progress]="evaluationProgress()"
    ></lib-result-progress-card>
    } @else {
    <lib-card>
      <ng-container title>Valutazione non ancora eseguita</ng-container>
      <ng-container content>
        <div class="flex flex-col items-center gap-6 pt-4 text-center">
          @if (permissions.canEditAny()) {
          <p class="text-lg text-gray-600">
            La proposta non è ancora stata valutata. Richiedi una nuova
            valutazione per ottenere il punteggio e il piano d'azione
            strategico.
          </p>
          <p-button
            severity="contrast"
            data-tour="request-evaluation"
            (click)="requestEvaluation()"
            styleClass="auto-compile-button"
            label="Richiedi valutazione"
          >
          </p-button>
          } @else {
          <p class="text-lg text-gray-600">
            La proposta non è ancora stata valutata. Il punteggio e il piano
            d'azione compariranno qui quando chi la compila richiederà la
            valutazione.
          </p>
          }
        </div>
      </ng-container>
    </lib-card>
    } } @else { @if (evaluationRequested()) {
    <lib-result-progress-card
      data-tour="result-progress"
      [progress]="evaluationProgress()"
    ></lib-result-progress-card>
    } @else if (permissions.canEditAny()) {
    <div class="flex w-full justify-end">
      <p-button
        label="Richiedi nuova valutazione"
        severity="secondary"
        data-tour="request-evaluation"
        (click)="requestEvaluation()"
        styleClass="auto-compile-button"
      />
    </div>
    }

    <lib-result-analyses-card
      class="block"
      data-tour="result-score"
      [score]="eval!.score"
      [maxScore]="eval!.maxScore"
      [technicalScore]="eval!.technicalScore"
      [technicalMaxScore]="eval!.technicalMaxScore"
      [economicScore]="eval!.economicOffer?.score"
      [economicMaxScore]="eval!.economicOffer?.maxScore"
      [description]="eval!.description"
    ></lib-result-analyses-card>

    @if (eval!.administrativeOffer) {
    <lib-result-administrative-offer-card
      class="block"
      [administrativeOffer]="eval!.administrativeOffer"
    ></lib-result-administrative-offer-card>
    } @if (eval!.economicOffer) {
    <lib-result-economic-offer-card
      class="block"
      [economicOffer]="eval!.economicOffer"
    ></lib-result-economic-offer-card>
    } @if (eval!.incoherenceReport) {
    <lib-result-incoherence-report-card
      class="block"
      [incoherenceReport]="eval!.incoherenceReport"
    ></lib-result-incoherence-report-card>
    }

    <lib-result-areas-card
      class="block"
      data-tour="result-areas"
      [strengthAreas]="eval!.strengths"
      [improvementAreas]="eval!.weaknesses"
    ></lib-result-areas-card>

    <div class="min-h-0 w-full flex-1 pb-2">
      <lib-result-strategic-plan-card
        class="block h-full w-full"
        [strategies]="eval!.actionPlanStrategies"
      ></lib-result-strategic-plan-card>
    </div>
    } } @else {
    <div class="flex w-full items-center justify-center">
      <div
        class="rounded-2xl border border-gray-200 bg-white p-6 text-center shadow-sm md:max-w-xl"
      >
        <h3 class="mb-6 text-2xl font-bold">Calcolo del punteggio in corso</h3>
        <p class="mb-8 text-lg text-gray-600">
          Stiamo attualmente calcolando il punteggio per questo bando. Questo
          può richiedere qualche momento — attendi e prova ad aggiornare tra
          poco.
        </p>
        <div class="flex items-center justify-center gap-3">
          <button pButton type="button" (click)="reload()">Aggiorna</button>
        </div>
      </div>
    </div>
    }
  </div>
</div>
